import React from 'react';
import { Check, Clock } from 'lucide-react';

const StatusPage = () => {
  const services = [
    { name: 'Stilos Web App', status: 'operational', uptime: '99.98%' },
    { name: 'API & Backend', status: 'operational', uptime: '99.95%' },
    { name: 'AI Article Generation', status: 'operational', uptime: '99.90%' },
    { name: 'Voice Transcription', status: 'operational', uptime: '99.90%' },
    { name: 'Brand Report Generation', status: 'operational', uptime: '99.90%' },
    { name: 'WordPress Publishing', status: 'operational', uptime: '99.95%' },
    { name: 'Payment Processing (Stripe)', status: 'operational', uptime: '99.99%' },
    { name: 'Email Service (Resend)', status: 'operational', uptime: '99.95%' },
  ];

  return (
    <div>
      <section className="py-20 px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-14">
            <span className="font-label text-[var(--color-coral)] mb-3 inline-block">STATUS</span>
            <h1 className="font-serif text-4xl md:text-5xl mb-4">System Status</h1>
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-green-50 text-green-700 text-sm font-medium">
              <Check className="w-4 h-4" />
              All systems operational
            </div>
          </div>

          <div className="card divide-y divide-[var(--color-border)]">
            {services.map((service, idx) => (
              <div key={idx} className="p-4 flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-2.5 h-2.5 rounded-full bg-green-500" />
                  <span className="text-sm">{service.name}</span>
                </div>
                <div className="flex items-center gap-4">
                  <span className="text-[10px] text-[var(--color-muted)]">{service.uptime} uptime</span>
                  <span className="text-xs text-green-700 font-medium capitalize">{service.status}</span>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-8 card p-6">
            <h2 className="font-serif text-lg mb-4">Recent Incidents</h2>
            <div className="text-center py-6">
              <p className="text-xs text-[var(--color-muted)]">No incidents reported in the last 30 days.</p>
            </div>
          </div>

          <p className="text-xs text-[var(--color-muted)] text-center mt-6">
            Last updated: {new Date().toLocaleDateString()} &middot; Status checked every 5 minutes
          </p>
        </div>
      </section>
    </div>
  );
};

export default StatusPage;
